import { render } from "./OwlDeleteButton.vue?vue&type=template&id=7cec5af6"
import script from "./OwlDeleteButton.vue?vue&type=script&lang=js"
export * from "./OwlDeleteButton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\siujilab\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__